module.exports = __webpack_public_path__ + "static/tw-25-cryptos-126e5ac72a44b7b47c842add98e5e816.jpg";